export default "<div>\n  <qrcode [qrdata]=\"getQRData()\" [size]=\"size\" *ngIf=\"integration\"></qrcode>\n</div>\n"